// The My prototypes page: a gallery of the prototypes of the owner that is logged in.
import "./analytics";
import type { PrototypeList } from "@feedmark/shared/api";
import { showAccount } from "./account";
import { client } from "./api";
import { $, errorText } from "./dom";
import "./own-embed";

type Item = PrototypeList["prototypes"][number];

const DAY_MS = 24 * 60 * 60 * 1000;

function card(item: Item): HTMLElement {
  const link = document.createElement("a");
  link.className = "tile";
  link.href = item.reviewUrl;

  // The thumbnail is the prototype itself, small. It is untrusted, thus it stays in a sandbox
  // and it gets no pointer events.
  const thumb = document.createElement("div");
  thumb.className = "thumb";
  const frame = document.createElement("iframe");
  frame.src = item.rawUrl;
  frame.title = "";
  frame.tabIndex = -1;
  frame.loading = "lazy";
  frame.referrerPolicy = "no-referrer";
  frame.setAttribute("sandbox", "allow-scripts");
  frame.setAttribute("aria-hidden", "true");
  thumb.append(frame);

  const name = document.createElement("strong");
  name.textContent = item.filename;

  const days = Math.max(1, Math.ceil((Date.parse(item.expiresAt) - Date.now()) / DAY_MS));
  const comments = item.openComments === 1 ? "1 open comment" : `${item.openComments} open comments`;
  const facts = document.createElement("span");
  facts.textContent = `${comments} · expires in ${days} ${days === 1 ? "day" : "days"}`;

  link.append(thumb, name, facts);
  return link;
}

async function load() {
  const user = await showAccount();
  $("loading").hidden = true;
  if (!user) {
    $("logged-out").hidden = false;
    return;
  }
  const response = await client.api.prototypes.$get();
  if (!response.ok) {
    $("alert").textContent = await errorText(response, "The prototypes did not load.");
    $("alert").hidden = false;
    return;
  }
  const { prototypes } = await response.json();
  $("empty").hidden = prototypes.length > 0;
  $("gallery").append(...prototypes.map(card));
}

load();
